import React from 'react';
import { Form, Input, message, Row, Icon, Col, AutoComplete, Checkbox } from 'antd';
import { alxd } from './VerifyInvoice';
import { invoiceImport, invoiceInput } from 'src/api';
import BaseImport, { IProps, create } from './BaseImport';
import debounce from 'lodash/debounce';
const FormItem = Form.Item;
const Option = AutoComplete.Option;
@create()
class Component extends BaseImport<IProps, any> {
    public queryTimeout: any;
    public textInput; any;
    constructor(props: IProps) {
        super(props);
        this.state = {
            value: '',
            loading: false,
            showCheck: false,
            tip: '开具金额(不含税)',
            url: this.props.url && this.props.url.scankey4,
            type: this.props.url && this.props.url.scankey4type,
            inputType: this.props.url.scaninputType,
            showFive: this.props.url.show || false,
            list: [],
            draftFlag: 1,
            showdeduction: this.props.url.deduction || false,
        };
        this.focusTextInput = this.focusTextInput.bind(this);
        this.fetchGroup = debounce(this.fetchGroup, 800);
    }
    handleSubmit = () => {
        this.props.form.validateFieldsAndScroll((err, values) => {
            if (!err) {
                this.setState({
                    value: null
                });
                const companyId = sessionStorage.getItem('companyId');
                const loggedUserId = sessionStorage.getItem('userId');
                const { inputType, draftFlag } = this.state;
                let data = {
                    ...values,
                    url: this.state.url,
                    companyId,
                    loggedUserId,
                    type: this.state.type,
                    inputType,
                    draftFlag
                };
                if (typeof data.url === 'function') {
                    data.url(data);
                } else {
                    invoiceImport.scanImport(this, data).then((res: any) => {
                        if (res.er) {
                            message.error(err.status.description);
                            return null;
                        } else {
                            super.callback();
                            this.success();
                        }
                    });
                }
            }
        });
    }
    resetForm = () => {
        const { resetFields } = this.props.form;
        resetFields();
    }
    success = () => {
        message.success('上传成功');
    }
    error = () => {
        message.error('上传失败，请稍后重新上传');
    }
    componentDidMount() {
        this.focusTextInput();
    }
    onScannerChange = (e) => {
        clearTimeout(this.queryTimeout);
        this.setState({
            value: e.target.value
        }, () => { this.queryTimeout = setTimeout(this.onGetqrcode, 200); });
    }
    onGetqrcode = () => {
        let code = this.state.value;
        let array = code.replace(/， /g, ',').split(',');
        console.log('array:', array);
        
        if (array.length < 7) {
            message.error('数据未识别');
            this.setState({
                value: null
            });
        } else {
            console.log('aaaaa',array[2],array[2].length);
            if (array[2].length > 1 && array[2].length < 10) {
                return null;
            }
            if (array[3].length < 8) {
                return null;
            }
           
            if(array[2].length === 1 && array[3].length === 20){ // 发票代码为空，并且发票号码为20位就是全电
                this.setState({
                    showCheck: false,
                    tip: '合计金额'
                });
            } else {
                let fplx = alxd(array[2]);//fplx 发票类型 
                if ((fplx === '01' || fplx === '02' || fplx === '03' ||  fplx === '15')) {
                    let tip = '';
                    if (fplx === '02') {
                        tip = '合计金额';
                    } else if (fplx === '03') {
                        tip = '不含税价';
                    } else if (fplx === '15') {
                        tip = '车价合计';
                    } else {
                        tip = '开具金额(不含税)';
                    }
                    this.setState({
                        showCheck: false,
                        tip: tip
                    });
                } else if (fplx === '04' || fplx === '10' || fplx === '11' || fplx === '14') {
                    this.setState({
                        showCheck: true
                    });
                }
            } 
            let r = new RegExp(/^[0-9]*$/);
            //console.log(r.test(array[2]),r.test(array[3]),r.test(array[5]),new RegExp(/^[0-9].*$/).test(array[4]))
            if ((array[2].length === 1 && array[3].length === 20) || r.test(array[2]) && r.test(array[3]) && r.test(array[5]) && new RegExp(/^[0-9].*$/).test(array[4])) {

                this.props.form.setFieldsValue({
                    invoiceCode: array[2] && array[2].trim(),
                    invoiceNumber: array[3],
                    invoiceDate: array[5].substring(0, 4) + '-' + array[5].substring(4, 6) + '-' + array[5].substring(6, 8),
                    amountWithoutTax: array[4],
                    invoiceParityCode: array[6].substr(-6, 6)
                });
                this.handleSubmit();

            } else {
                message.error('数据未识别');
                this.setState({
                    value: null
                });
            }

        }
    }

    onScannerBlur = () => {
        this.textInput.focus();
    }
    focusTextInput() {
        this.textInput.focus();
    }
    onAddGroup = () => {
        invoiceInput.CreatGroup(this, {}).then((response: any) => {
            const err2 = response.er;
            const res = response.res;
            if (err2) {
                return null;
            } else {
                if (res) {
                    message.success('操作成功');
                    this.props.form.setFieldsValue({ groupNumber: res });
                }
            }
        });
    }
    fetchGroup = (value) => {
        const groupNumber = value;
        if (groupNumber) {
            invoiceInput.GetGroupList(this, { groupNumber }).then((response: any) => {
                const err = response.er;
                const res = response.res;
                if (err) {
                    return null;
                } else {
                    if (res) {
                        this.setState({
                            list: res
                        });
                    }
                }
            });
        }
    }
    onChange = (e) => {
        if (e.target.checked) {
            this.setState({
                draftFlag: 1
            });
        } else {
            this.setState({
                draftFlag: 0
            });
        }
    }
    render() {
        let formItemLayout = {
            labelCol: { span: 8 },
            wrapperCol: { span: 16 },
        };
        const { getFieldDecorator } = this.props.form;
        const options = this.state.list.map(d => <Option key={d.groupNumber}>{d.groupNumber}</Option>);
        return (
            <div >
                <Form >
                    <Row>
                        <Col span={21}>
                            <FormItem {...formItemLayout} label="扫码输入" style={{ height: 0, opacity: 0 }}>
                                <Input ref={(input) => { this.textInput = input; }} onChange={this.onScannerChange} value={this.state.value} />
                            </FormItem>
                        </Col>
                    </Row>
                    <Row>
                        <Col span={21}>
                            <FormItem {...formItemLayout} label="发票代码">
                                {getFieldDecorator('invoiceCode'
                                )(
                                    <Input readOnly={true} onClick={this.onScannerBlur} />
                                )}
                            </FormItem>
                        </Col>
                    </Row>
                    <Row>
                        <Col span={21}>
                            <FormItem {...formItemLayout} label="发票号码">
                                {getFieldDecorator('invoiceNumber')(
                                    <Input readOnly={true} onClick={this.onScannerBlur} />
                                )}
                            </FormItem>
                        </Col>
                    </Row>
                    <Row>
                        <Col span={21}>
                            <FormItem
                                {...formItemLayout}
                                label="开票日期"
                            >
                                {getFieldDecorator('invoiceDate')(
                                    <Input readOnly={true} onClick={this.onScannerBlur} />
                                )}
                            </FormItem>
                        </Col>
                    </Row>
                    <Row>
                        <Col span={21}>
                            <FormItem {...formItemLayout} label={this.state.tip} className={this.state.showCheck ? 'hide' : ''}>
                                {getFieldDecorator('amountWithoutTax')(
                                    <Input readOnly={true} onClick={this.onScannerBlur} />
                                )}
                            </FormItem>
                        </Col>
                    </Row>
                    <Row>
                        <Col span={21}>
                            <FormItem {...formItemLayout} label="校验码" className={this.state.showCheck ? '' : 'hide'}>
                                {getFieldDecorator('invoiceParityCode')(
                                    <Input readOnly={true} />
                                )}
                            </FormItem>
                        </Col>
                    </Row>
                    {
                        this.state.showFive &&
                        <Row>
                            <Col span={21} >
                                <FormItem {...formItemLayout} label="指定到发票组">
                                    {getFieldDecorator('groupNumber', {
                                        rules: [{ message: '请输入编号(最大长度36位)', max: 36 }]
                                    })(
                                        <AutoComplete
                                            onSearch={this.fetchGroup}
                                        >
                                            {options}
                                        </AutoComplete>
                                    )}
                                </FormItem>
                            </Col>
                            <Col span={2} offset={1}>
                                <span style={{ lineHeight: '39px' }} className="hand" onClick={this.onAddGroup}><Icon type="plus" /></span>
                            </Col>
                        </Row>
                    }
                    {
                        this.state.showdeduction &&
                        <Row>
                            <FormItem {...formItemLayout} >
                                {getFieldDecorator('draftFlag', {
                                    valuePropName: 'checked',
                                    initialValue: !!this.state.draftFlag
                                })(
                                    <Checkbox onChange={this.onChange} >录入时勾选发票</Checkbox>
                                )}
                            </FormItem>
                        </Row>
                    }
                </Form>

                <div style={{ 'padding': '10px 0px 0', 'borderTop': '1px solid #cccccc', 'color': '#999999' }}>请将扫码枪靠近发票二维码，并保证二维码清晰，系统会自动进行发票录入。(扫码多次失败可以尝试把输入法设置成小写)</div>
            </div>
        );
    }

}
const ScanImport = Form.create()(Component);
export default ScanImport;



// WEBPACK FOOTER //
// ./src/node_modules/kts-platform-frame/display/part/InvoiceImport/InvoiceTab/ScanImport.tsx